import React from "react";
import { Link } from "react-router-dom";
import { APP_STORE_URL, PLAY_STORE_URL } from "../site/constants";
import { IconArrow } from "../site/icons";
import SiteLayout from "./SiteLayout";

export default function ContentPage({
  title,
  lead,
  children,
  ctaLabel = "Start met bestellen",
  ctaHref = APP_STORE_URL,
  secondaryLabel,
  secondaryTo,
}) {
  return (
    <SiteLayout>
      <section className="lp-page">
        <div className="lp-wrap lp-page-inner">
          <Link to="/" className="lp-back">
            ← Terug naar home
          </Link>
          <h1 className="lp-page-title">{title}</h1>
          {lead && <p className="lp-page-lead">{lead}</p>}
          <div className="lp-page-body">{children}</div>
          {ctaLabel || secondaryLabel ? (
            <div className="lp-page-cta">
              {ctaLabel ? (
                <a
                  className="lp-btn-primary"
                  href={ctaHref}
                  target={ctaHref.startsWith("mailto:") ? undefined : "_blank"}
                  rel={
                    ctaHref.startsWith("mailto:")
                      ? undefined
                      : "noopener noreferrer"
                  }
                >
                  {ctaLabel}
                  <span className="lp-btn-arrow">
                    <IconArrow />
                  </span>
                </a>
              ) : null}
              {secondaryLabel && secondaryTo ? (
                <Link className="lp-btn-ghost" to={secondaryTo}>
                  {secondaryLabel}
                </Link>
              ) : null}
              {secondaryLabel && !secondaryTo ? (
                <a
                  className="lp-btn-ghost"
                  href={PLAY_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {secondaryLabel}
                </a>
              ) : null}
            </div>
          ) : null}
        </div>
      </section>
    </SiteLayout>
  );
}

export function Block({ title, children, id }) {
  return (
    <section className="lp-block" id={id}>
      {title && <h2>{title}</h2>}
      {children}
    </section>
  );
}

export function CardGrid({ items }) {
  return (
    <div className="lp-card-grid">
      {items.map((item) => (
        <article key={item.title} className="lp-info-card">
          <h3>{item.title}</h3>
          <p>{item.body}</p>
          {item.price && <span className="lp-package-price">{item.price}</span>}
        </article>
      ))}
    </div>
  );
}

export function BulletList({ items }) {
  return (
    <ul className="lp-bullet-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

export function Steps({ items }) {
  return (
    <div className="lp-steps lp-steps--page">
      {items.map((step, i) => (
        <article key={step.title} className="lp-step">
          <span className="lp-step-n">{step.n || i + 1}</span>
          <h3>{step.title}</h3>
          <p>{step.body}</p>
        </article>
      ))}
    </div>
  );
}
